var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg2Canton = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-15",
    transform: "translate(-1221.000000, -141.000000)",
    fill: "#525252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1221.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(11.276500, 10.596300) rotate(-90.000000) translate(-11.276500, -10.596300) ",
    points: "6.52175 11.6831 16.03125 11.6831 16.03125 9.5095 6.52175 9.5095"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(5.842500, 7.879300) rotate(-90.000000) translate(-5.842500, -7.879300) ",
    points: "-1.62925 8.9661 13.31425 8.9661 13.31425 6.7925 -1.62925 6.7925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(1.087750, 11.954800) rotate(-90.000000) translate(-1.087750, -11.954800) ",
    points: "-2.3085 10.868 -2.3085 13.0416 4.484 13.0416 4.484 10.868"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2Canton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2_Canton.ceb4b421.svg";
export { ForwardRef as ReactComponent };